import React from "react";
import { motion } from "framer-motion";
import { Check, Crown, Sparkles, Gift, Quote, ShieldCheck, Bot } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";
import { Button } from "../../components/ui/button";

export const FunnelIntro = ({ funnel, testimonials, aiChat, hasQuiz, questionsCount, onStart }) => (
  <motion.div key="intro" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="text-center">
    <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-purple-300 border border-purple-500/40 rounded-full px-4 py-1.5 mb-6">
      <Crown size={14} className="text-yellow-400" /> Oportunidad de negocio
    </div>
    <h1 className="font-display font-black tracking-tighter text-4xl sm:text-5xl leading-tight">{funnel.headline}</h1>
    <p className="text-zinc-300 mt-4">{funnel.subheadline}</p>

    {funnel.lead_magnet && (
      <div className="mt-5 inline-flex items-center gap-2 bg-yellow-400/10 border border-yellow-400/30 rounded-full px-4 py-2 text-sm text-yellow-impact font-semibold">
        <Gift size={16} /> Gratis: {funnel.lead_magnet.replace(/^\s*(gratis|gratuito|guía gratuita|guia gratuita)\s*:?\s*/i, "")}
      </div>
    )}

    {funnel.video_url && (
      <video data-testid="funnel-video" src={funnel.video_url} controls playsInline className="mt-6 rounded-2xl border border-white/10 w-full max-h-80 object-cover bg-black" />
    )}
    {!funnel.video_url && funnel.image_url && (
      <img data-testid="funnel-image" src={`${BACKEND_URL}${funnel.image_url}`} alt="" className="mt-6 rounded-2xl border border-white/10 w-full object-cover" />
    )}

    {funnel.benefits?.length > 0 && (
      <ul className="space-y-2.5 my-7 text-left max-w-sm mx-auto">
        {funnel.benefits.map((b) => (
          <li key={b} className="flex items-center gap-3 text-zinc-200">
            <span className="w-6 h-6 rounded-full bg-purple-600 flex items-center justify-center shrink-0"><Check size={14} /></span>{b}
          </li>
        ))}
      </ul>
    )}

    {testimonials.length > 0 && (
      <div data-testid="funnel-testimonials" className="space-y-3 my-7 text-left">
        {testimonials.map((t, i) => (
          <div key={`${t.text}-${i}`} className="rounded-xl border border-white/10 bg-[#121212] p-4">
            <Quote size={16} className="text-purple-400 mb-1.5" />
            <p className="text-sm text-zinc-200 italic">"{t.text}"</p>
            {t.author && <p className="text-xs text-zinc-500 mt-2">— {t.author}</p>}
          </div>
        ))}
      </div>
    )}

    <Button data-testid="funnel-start" onClick={onStart} className="w-full bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-xl py-6 text-base mt-2">
      {aiChat ? <><Bot size={18} className="mr-2" /> Platica con nuestro asesor</> : hasQuiz ? <><Sparkles size={18} className="mr-2" /> Responde y descúbrelo</> : (funnel.cta_text || "Quiero más información")}
    </Button>
    {aiChat && <p className="text-xs text-zinc-500 mt-3">Te atenderá nuestro asesor inteligente en una breve charla 💬</p>}
    {!aiChat && hasQuiz && <p className="text-xs text-zinc-500 mt-3">Solo {questionsCount} preguntas rápidas y divertidas ⚡</p>}
    {funnel.privacy_note && (
      <p className="text-[11px] text-zinc-600 mt-4 flex items-start gap-1.5 max-w-sm mx-auto">
        <ShieldCheck size={13} className="shrink-0 mt-0.5" /> {funnel.privacy_note}
      </p>
    )}
  </motion.div>
);
